/**
 * created by lzy 2020-03-09
 */
'use strict';
angular.module('editPageButtonForWeiboModule', []).directive('editpageButtonWeibo', ['$state', '$timeout', '$window', 'editcenterRightsService', 'editingCenterWeiBoService', 'trsHttpService', 'storageListenerService', 'modalDialog', 'noticeWindowService', '$stateParams', 'editingMediatype', 'localStorageService', 'publicToolService', 'newMediaService', 'messagePublishService', 'weiboConst',
    function ($state, $timeout, $window, editcenterRightsService, editingCenterWeiBoService, trsHttpService, storageListenerService, modalDialog, noticeWindowService, $stateParams, editingMediatype, localStorageService, publicToolService, newMediaService, messagePublishService, weiboConst) {
        return {
            scope: true,
            restrict: 'E',
            templateUrl: './editingCenter/weibo/directive/editPageButtonForWeibo/editpageButtonForWeibo.html',
            replace: true,
            link: function ($scope) {
                initStatus();
                initData();

                /**
                 * [initStatus description] 初始化状态
                 *
                 * @return  {[type]}  [return description]
                 */
                function initStatus() {
                    $scope.status = {
                        isawaitrevise: !!$state.params.isawaitrevise,
                        platform: $state.params.wbplatform,
                    };
                    $scope.data = {
                        trench: weiboConst.listenStroageKey
                    };
                }

                /**
                 * [initData description] 初始化数据
                 *
                 * @return  {[type]}  [return description]
                 */
                function initData() {
                    initBtnRights();
                    emitCloseWindow();
                }

                /**
                 * [initBtnRights description] 初始化权限
                 * @return {[type]} [description]
                 */
                function initBtnRights() {
                    editcenterRightsService
                        .initWeiboListBtn($scope.status.platform === '0' ? 'microblog.daibian' : 'microblog.daishen', $state.params.wbchannelid)
                        .then(function (rights) {
                            $scope.status.btnRights = rights;
                        });
                    publicToolService.getModeconfiguration('IM').then((config) => {
                        $scope.status.IM = config;
                    });
                }

                $scope.confirm = function () {
                    $scope.doSave(true).then(function (docid) {
                        editingCenterWeiBoService.lockWeibo(docid);
                    });
                };

                /**
                 * [trial description] 送审
                 * @return {[type]} [description]
                 */
                $scope.trial = function () {
                    newMediaService.trial($scope, {serviceid: 'wcm61_scmmicrocontent', methodname: 'processToTrialToJson'}).then((opinion) => {
                        $scope.doSave(false).then(function (docid) {
                            let trialParams = angular.extend({
                                ObjectIds: docid,
                            }, {serviceid: 'wcm61_scmmicrocontent', methodname: 'processToTrialToJson'});
                            messagePublishService.publish('doEditPageOperation', trialParams);
                        });
                    });
                };

                /**
                 * [directSign description] 直接签发
                 * @return {[type]} [description]
                 */
                $scope.directSign = function () {
                    $scope.doSave(false).then(function (docid) {
                        directSign(docid);
                    });
                };

                /**
                 * [directSign description]
                 *
                 * @param   {[type]}  docid  [docid description]
                 *
                 * @return  {[type]}         [return description]
                 */
                function directSign(docid) {
                    $scope.loadingPromise = noticeWindowService.getAccountValidityInfo(editingMediatype.weibo).then(
                        function () {
                            let list = angular.copy($scope.list);
                            list.SCMMICROCONTENTID = docid;
                            editingCenterWeiBoService.directSignWeibo([list], false, $scope.parentStatus.platform === '0' ? '40' : '20', function (result) {
                                editingCenterWeiBoService.unlockWeibo(JSON.parse($state.params.wbmetadataid));
                                modalDialog.alertType('签发成功', '', 'success', false,
                                    function () {
                                        storageListenerService.addListenerToWeibo('directSign');
                                        $window.close();
                                    }, '', 1500);
                            }, function () {
                                storageListenerService.addListenerToWeibo('directSign');
                                $window.close();
                            });
                        }
                    );
                }

                /**
                * [timingSign description]
                * @return  {[type]}  [return description]
                */
                $scope.timingSign = function () {
                    $scope.doSave(false).then(function (docid) {
                        timingSign(docid);
                    });
                };

                /**
                 * [timingSign description] 定时签发
                 *
                 * @param   {[type]}  docid  [docid description] 稿件id
                 *
                 * @return  {[type]}         [return description]
                 */
                function timingSign(docid) {
                    $scope.loadingPromise = noticeWindowService.getAccountValidityInfo(editingMediatype.weibo).then(
                        function () {
                            let list = angular.copy($scope.list);
                            list.SCMMICROCONTENTID = docid;
                            editingCenterWeiBoService.timeSignWeibo([list], false, $scope.parentStatus.platform === '0' ? '40' : '20', function (result) {
                                editingCenterWeiBoService.unlockWeibo(JSON.parse($state.params.wbmetadataid));
                                modalDialog.alertType(
                                    '定时签发成功',
                                    '',
                                    'success',
                                    false,
                                    function () {
                                        storageListenerService.addListenerToWeibo('timeSign');
                                        $window.close();
                                    },
                                    '',
                                    1500
                                );
                            }, function () {
                                storageListenerService.addListenerToWeibo('timeSign');
                                $window.close();
                            });
                        }
                    );
                }

                /**
                 * [withdraw description] 撤稿
                 * @return {[type]} [description]
                 */
                $scope.withdraw = function () {
                    $scope.doSave(false).then(function (docid) {
                        editingCenterWeiBoService.withdrawWeibo([$scope.list], function (result) {
                            modalDialog.alertType('撤稿成功', '', 'success', false,
                                function () {
                                    storageListenerService.addListenerToWeibo('withdraw');
                                    $window.close();
                                }, '', 1500);
                        });
                    });
                };

                /**
                * [revise 修订]
                *
                * @return  {[type]}
                *   [return description]
                */
                $scope.revise = function () {
                    modalDialog.confirmModal('修订', '确认修订?', function () {
                        $scope.doSave(false).then(function (data) {
                            var params = {
                                serviceid: 'mlf_modifydoc',
                                methodname: 'newMediaModifyDocsFinished',
                                NewDocId: $state.params.wbmetadataid,
                                MediaType: '5',
                            };
                            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post', true).then(
                                function (data) {
                                    modalDialog.alertType('修订成功', '', 'success', false, function () { });
                                    storageListenerService.addListenerToWeibo('revise');
                                    $timeout(function () {
                                        $window.close();
                                    }, 2000);
                                },
                                function (data) {
                                    modalDialog.alertType('修订失败', data.message, 'error', 'confirm', function () {
                                        storageListenerService.addListenerToWeibo('revise');
                                        $window.close();
                                    });
                                }
                            );
                        });
                    });
                };

                /**
                 * [close description] 关闭
                 * @return {[type]} [description]
                 */
                $scope.close = function () {
                    if ($scope.parentStatus.wbMetadataId == 0) {
                        $window.close();
                    } else {
                        editingCenterWeiBoService.unlockWeibo($scope.parentStatus.wbMetadataId).then(function (data) {
                            $window.close();
                        });
                    }
                };

                /**
                 * [emitCloseWindow description]标签页关闭页面时，发送稿件解锁信息给其他页面，协助解锁该稿件
                 * @return {[type]} [description]
                 */
                function emitCloseWindow() {
                    window.onbeforeunload = function () {
                        localStorageService.set(
                            'unLockWeibo',
                            JSON.stringify({
                                metadataid: $stateParams.wbmetadataid,
                            })
                        );
                    };
                }
            }
        };
    }
]);
